import client from "../client";

export const growthApi = {
    async list(childId) {
        const { data } = await client.get(`/growth/${childId}`);
        return data;
    },
    async create(childId, record) {
        const { data } = await client.post(`/growth/${childId}`, record);
        return data;
    },
    async update(childId, recordId, record) {
        const { data } = await client.put(`/growth/${childId}/${recordId}`, record);
        return data;
    },
    async remove(childId, recordId) {
        const { data } = await client.delete(`/growth/${childId}/${recordId}`);
        return data;
    },
};
